import Vue from 'vue';
import api from '@/services/api';
const jwt_decode = require('jwt-decode');

function hasTokenExpired(token) {
  if (token) {
    const decodedToken = jwt_decode(token);
    const currentTime = Math.floor(new Date().getTime() / 1000);
    const adjustedTime = currentTime + 7200;
    // console.log('***********************************');
    // console.log('Created at:', decodedToken.iat);
    // console.log('Current time:', currentTime);
    // console.log('Adjusted', adjustedTime);
    // console.log('Expires', decodedToken.exp);
    // console.log('Token valid for:', (decodedToken.exp - adjustedTime));
    // console.log('***********************************');
    if (decodedToken.exp && decodedToken.exp > adjustedTime) {
      return false;
    }
  }
  return true;
}

async function checkToken(state, dispatch) {
  // console.log(
  //   'Checking active token -->',
  //   Vue.axios.defaults.headers.common['Authorization']
  // );
  // console.log('checking token details');
  const inUseToken = Vue.axios.defaults.headers.common['Authorization'];
  if (!inUseToken) {
    if (state.token && !hasTokenExpired(state.token)) {
      // console.log('loading token from store:', state.token);
      Vue.axios.defaults.headers.common[
        'Authorization'
      ] = `Bearer ${state.token}`;
    } else {
      // console.log('refreshing token...');
      const { token } = await dispatch('refresh');
      if (token) {
        Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      }
    }
  } else {
    // check the token expiration date (remove word Bearer from start
    const testToken = inUseToken.length > 7 ? inUseToken.slice(7) : inUseToken;
    if (hasTokenExpired(testToken)) {
      const { token } = await dispatch('refresh');
      if (token) {
        Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      }
    }
  }
}

function handleError(commit, error) {
  if (error.message === 'Failed to fetch') {
    error.message = 'Unable to connect. Please check your Internet connection.';
  }
  commit('RESET_USER');
  return error;
}

export default {
  namespaced: true,
  state: {
    user: null,
    isVerified: false,
    users: [],
    team: null,
    apiKey: null,
    account: null,
    token: null,
    refresh: null
  },
  getters: {
    loggedIn: state => {
      return !!state.user;
    },
    token: state => {
      // is token in state? If not check cookie
      if (state && state.token) {
        return state.token;
      }
      return localStorage.gmxt || '';
    },
    teamId: state => {
      if (state && state.team) {
        return state.team._id;
      }
    },
    apiKey: state => {
      if (state && state.team) {
        return state.team.apiKey;
      }
    },
    teamname: state => {
      if (state && state.team) {
        return state.team.name || '';
      }
      return '';
    },
    username: state => {
      if (state && state.user) {
        return (
          state.user.nickname ||
          state.user.firstname ||
          state.user.email ||
          'Account'
        );
      }
      return '';
    },
    userId: state => {
      if (state && state.user) {
        return state.user._id;
      }
    },
    fullname: state => {
      if (state && state.user) {
        return (
          `${state.user.firstname} ${state.user.lastname}`.trim() ||
          state.user.nickname ||
          state.user.email ||
          'Account'
        );
      }
      return '';
    },
    avatarSource: state => {
      if (state && state.user) {
        return state.user.avatar;
      }
      return 'https://www.gravatar.com/avatar/null?s=200&d=mp';
    },
    isTeamOwner: state => {
      if (state && state.user && state.team) {
        return !!state.team.owners.includes(state.user._id);
      }
      return false;
    }
  },
  mutations: {
    SET_USER(store, data) {
      store.user = data;
      store.isVerified = data.verifiedEmail;
    },
    SET_USERS(store, data) {
      store.users = data;
    },
    SET_TEAM(store, data) {
      store.team = data;
      store.apiKey = data.apiKey;
    },
    SET_ACCOUNT(store, data) {
      store.account = data;
    },
    SET_TOKEN(store, data) {
      // console.log('setting token:', data);
      localStorage.gmxt = data;
      // cookies.set('gm-token', data, { expires: 0.5 });
      Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${data}`;
      store.token = data;
    },
    SET_REFRESH(store, data) {
      //cookies.remove('gm-refresh');
      //cookies.set('gm-refresh', data, { expires: 364 });
      // console.log('refresh:', data);
      localStorage.gmxr = data;
      store.refresh = data;
    },
    RESET_USER(store) {
      store.user = null;
      store.users = [];
      store.team = null;
      store.account = null;
      store.token = null;
      store.apiKey = null;
      // cookies.remove('gm-token');
      // cookies.remove('gm-refresh');
      localStorage.gmxt = '';
      localStorage.gmxr = '';
      delete Vue.axios.defaults.headers.common['Authorization'];
    }
  },
  actions: {
    async refresh({ commit }) {
      try {
        // console.log('Refreshing token (if token good)');
        const refresh = localStorage.gmxr; // cookies.get('gm-refresh');
        if (refresh) {
          const { data: response } = await api.refreshToken({
            refreshId: refresh,
            sourceId: 'handlers-login'
          });
          if (response && response.success) {
            commit('SET_USER', response.user);
            commit('SET_USERS', response.users);
            commit('SET_TEAM', response.team);
            if (response.account) commit('SET_ACCOUNT', response.account);
            commit('SET_TOKEN', response.token);
            commit('SET_REFRESH', response.refresh._id);
          }
          return response;
        }
      } catch (error) {
        console.log('auth/refresh error:', error);
        // return handleError(commit, error);
      }
    },
    async login({ commit }, credentials) {
      try {
        const { data: response } = await api.login(credentials);
        if (response && response.success) {
          commit('SET_USER', response.user);
          commit('SET_USERS', response.users);
          commit('SET_TEAM', response.team);
          if (response.account) commit('SET_ACCOUNT', response.account);
          commit('SET_TOKEN', response.token);
          commit('SET_REFRESH', response.refresh._id);
          // login / team helper setting
          localStorage[response.user.email] = response.team._id;
        }
        return response;
      } catch (error) {
        // console.log('auth/login error', error);
        return handleError(commit, error);
      }
    },
    async getUser({ commit, dispatch, state }) {
      try {
        // console.log('get user called');
        checkToken(state, dispatch);
        const [userData, ipAddress] = await Promise.all([
          api.getUser(),
          api.getUserIP()
        ]);
        const response = { ...userData.data, ...ipAddress.data };
        console.log('user response:', response);
        if (response) {
          commit('SET_USER', response);
        }
        return response;
      } catch (error) {
        // console.log('auth/getUser error', error);
        return handleError(commit, error);
      }
    },
    async getTeam({ commit, dispatch, state }) {
      try {
        // console.log('firing off getTeam');
        checkToken(state, dispatch);
        const { data: response } = await api.getTeam();
        if (response) {
          // console.log('updating state...');
          commit('SET_TEAM', response.team);
          commit('SET_USERS', response.users);
          if (response.account) commit('SET_ACCOUNT', response.account);
        }
        return response.team;
      } catch (error) {
        // console.log('auth/getTeam error', error);
        return handleError(commit, error);
      }
    },
    // stupid naming issue - getAccount in Auth, not account store. WTF was I thinking...
    // Account store is really the app
    async getAccount({ commit, dispatch, state }) {
      try {
        await checkToken(state, dispatch);
        const { data: response } = await api.getAccount();
        if (response && !response.error) {
          commit('SET_ACCOUNT', response);
        }
        return response;
      } catch (e) {
        // console.log('auth/getAccount error', e);
        return handleError(commit, e);
      }
    },
    // eslint-disable-next-line no-unused-vars
    lastTeam({ commit }, { email, teamId }) {
      return localStorage[email] || teamId;
    },
    resetUser({ commit }) {
      commit('RESET_USER');
    },
    reloadUser({ commit, state, dispatch }, updatedUserData) {
      if (state.user._id === updatedUserData._id) {
        commit('SET_USER', updatedUserData);
      } else {
        // different user in team has updated, cause an update to happen to team here?
        dispatch('getTeam');
      }
    },
    reloadTeam({ commit }, updatedTeamData) {
      commit('SET_TEAM', updatedTeamData);
    },
    reloadUsers({ commit }, updatedUsersData) {
      commit('SET_USERS', updatedUsersData);
    },
    reloadAccount({ commit }, updatedAccountData) {
      commit('SET_ACCOUNT', updatedAccountData);
    }
  }
};
